/**
 * Résolution du chemin in-app d'une notification tapée.
 *
 * Le payload porte la destination dans `data.url` (web `sw.js` comme FCM natif).
 * On n'accepte qu'un chemin INTERNE absolu (`/…`) : jamais une URL externe ni un
 * schéma exotique — garde anti-open-redirect. PUR & testé (`deep-link.test.ts`).
 */
export function resolveNotificationPath(data: unknown): string | null {
  if (!data || typeof data !== 'object') return null;
  const raw = (data as Record<string, unknown>).url;
  if (typeof raw !== 'string') return null;
  const url = raw.trim();
  // Un seul '/' de tête : rejette '//host', 'http(s)://…', 'javascript:…',
  // 'fr.jeraisonne.app://…' et les chemins relatifs.
  if (!url.startsWith('/') || url.startsWith('//')) return null;
  return url;
}
